import { Action, InitialFiltersMarketPremiumTypes } from '@state/actions/Type';
import { getInitialState, InitialFilter } from '../initial-filter/InitialFiltersReducer';

export interface InitialFiltersMarketPremiumState {
  initialFilters: InitialFilter[];
}

const InitialFiltersMarketPremiumReducer = (
  state: InitialFiltersMarketPremiumState = getInitialState(), // NOSONAR typescript:S1788
  action: Action,
) => {
  if (action.type === InitialFiltersMarketPremiumTypes.InitialFiltersMarketPremiumUpdate) {
    return {
      ...state,
      initialFilters: action.payload.initialFilters,
    };
  }
  return state;
};

export default InitialFiltersMarketPremiumReducer;
